import { render, staticRenderFns } from "./OtherInformationStep.vue?vue&type=template&id=8608c548&"
import script from "./OtherInformationStep.vue?vue&type=script&lang=js&"
export * from "./OtherInformationStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports